/**
 * 会員の画面の URL。<b>今のアプリと同じ形</b>（メールや外部に載った URL を切らない）。
 *
 * 移行元のルート（Program.cs の <c>TenantUser</c>）に合わせてあり、
 * 利用者の管理だけは <c>/tenant/Edit/{契約}/TenantUser/…</c> の形になる。
 */
export const memberUrls = {
    tenants: "/Tenant",
    newTenant: "/Tenant/New",
    /** 契約情報（契約 1 件の中身と操作。一覧の「契約情報」から開く）。 */
    tenantDetail: (tenantId: number): string => `/Tenant/Detail/${String(tenantId)}`,
    changePlan: (tenantId: number): string => `/Tenant/ChangePlan/${String(tenantId)}`,
    editTenant: (tenantId: number): string => `/Tenant/Edit/${String(tenantId)}`,
    changeCard: (tenantId: number): string => `/Tenant/Card/${String(tenantId)}`,
    /** 接続を許可する IP アドレス。 */
    ipRestriction: (tenantId: number): string => `/Tenant/IpRestriction/${String(tenantId)}`,
    cancelTenant: (tenantId: number): string => `/Tenant/Delete/${String(tenantId)}`,
    invoices: (tenantId: number): string => `/TenantInvoice/Index?tenantId=${String(tenantId)}`,
    tenantUsers: (tenantId: number): string => `/tenant/Edit/${String(tenantId)}/TenantUser/Index`,
    /** プリザンター本体（/fs）。AGW が App Service へ振り分ける（Implem.Portal.Backend の docs/04 §0-2）。 */
    service: (serviceId: string): string => `/${serviceId}`,
} as const;
